export enum LegalRoutes {
  Root = "",
  Settings = "settings",
  TSS = "tss",
  /** DSFinV-K data exports (#770) — create, watch, download. */
  Exports = "exports",
  /**
   * TSE data exports (#776) — the security device's own signed log messages.
   *
   * Its own route rather than a tab of {@link Exports}: the two are different artefacts in law (§ 4
   * KassenSichV Satz 1 names both, Satz 4 permits the interfaces to be published separately), they are
   * requested differently (no register filter here at all) and an operator is sent to exactly one of them by
   * whoever asked for the file.
   */
  TseExports = "tse-exports",
  /**
   * Correcting filed cash point closings (#771): withdraw closings and file them again from the stored data.
   * Its own route because it changes filed records, where the two export screens only read them.
   */
  ClosingCorrections = "closing-corrections",
}
